// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Fetch from "bs-fetch/src/Fetch.bs.js";
import * as Datadog from "../bindings/Datadog.bs.js";
import * as Js_dict from "@rescript/std/lib/es6/js_dict.js";
import * as $$Request from "../common/Request.bs.js";
import * as Segment from "../bindings/Segment.bs.js";
import * as CardData from "./Data/CardData.bs.js";
import * as Customer from "./Data/Customer.bs.js";
import * as ApiErrors from "./ApiErrors.bs.js";
import * as AuthUtils from "../auth/user/AuthUtils.bs.js";
import * as Belt_List from "@rescript/std/lib/es6/belt_List.js";
import * as ErrorData from "./Data/ErrorData.bs.js";
import * as LoginData from "./Data/LoginData.bs.js";
import * as OrderData from "./Data/OrderData.bs.js";
import * as TokenData from "./Data/TokenData.bs.js";
import * as JsCookie from "js-cookie";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_format from "@rescript/std/lib/es6/caml_format.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as HistoryData from "./Data/HistoryData.bs.js";
import * as OrderStatus from "./Data/OrderStatus.bs.js";
import * as CustomerData from "./Data/CustomerData.bs.js";
import * as ExchangeData from "./Data/ExchangeData.bs.js";
import * as RegisterData from "./Data/RegisterData.bs.js";
import * as MyDetailsData from "./Data/MyDetailsData.bs.js";
import * as CreditCardData from "./Data/CreditCardData.bs.js";
import * as ResendGiftData from "./Data/ResendGiftData.bs.js";
import * as RegisterResponseData from "./Data/RegisterResponseData.bs.js";
import * as EditScheduleDeliveryData from "./Data/EditScheduleDeliveryData.bs.js";

function login(login$1) {
  var payload = LoginData.Encode.login(login$1);
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined)));
  var callback = function (response) {
    return $$Request.checkResponse(response, TokenData.Decode.safeDecodeTokenData);
  };
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* Include */2, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Request.makeRequest($$Request.makeUrl("api/v3/signin-by-email-password/email/"), request, headerlessRequest, callback, true);
}

function register(registerData) {
  var payload = RegisterData.Encode.register(registerData);
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withSecurityToken(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, RegisterResponseData.Decode.safeDecodeRegisterResponse);
  };
  return $$Request.makeRequest($$Request.makeUrl("api/v3/register-by-email-password/email/"), request, headerlessRequest, callback, true);
}

function account(firstName, lastName) {
  var payload = Js_dict.fromList({
        hd: [
          "first_name",
          firstName
        ],
        tl: {
          hd: [
            "last_name",
            lastName
          ],
          tl: /* [] */0
        }
      });
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var url = $$Request.makeUrl("api/v3/customer/");
  var request = Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Put */3, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                var n = response.status;
                if (n !== 200) {
                  if (n >= 400 && n < 500) {
                    return Js_promise.then_((function (json) {
                                  return Promise.resolve(ErrorData.Decode.safeDecodeError(json));
                                }), Fetch.$$Response.json(response));
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Js_promise.then_((function (json) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: Customer.Decode.safeDecodeCustomer(json)
                                          });
                              }), Fetch.$$Response.json(response));
                }
              }), fetch(url, request));
}

function forgotEmailAddress(phone) {
  var payload = Js_dict.fromList({
        hd: [
          "phone",
          phone
        ],
        tl: /* [] */0
      });
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var url = $$Request.makeUrl("api/v3/forgot-email-address/");
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                var n = response.status;
                if (n !== 204) {
                  if (n >= 400 && n < 500) {
                    return Js_promise.then_((function (json) {
                                  return Promise.resolve(ErrorData.Decode.safeDecodeError(json));
                                }), Fetch.$$Response.json(response));
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: response
                            });
                }
              }), fetch(url, request));
}

function resetPassword(email) {
  var payload = Js_dict.fromList({
        hd: [
          "email_address",
          email
        ],
        tl: /* [] */0
      });
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var url = $$Request.makeUrl("api/v3/reset-password/");
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                var n = response.status;
                if (n !== 204) {
                  if (n >= 400 && n < 500) {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: {
                                  TAG: /* ServerError */2,
                                  _0: {
                                    TAG: /* ServerValidationError */0,
                                    _0: "Invalid Email Address"
                                  }
                                }
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: response
                            });
                }
              }), fetch(url, request));
}

function changeEmailAddress(param) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.build(undefined)));
  var url = $$Request.makeUrl("api/v3/change-email-address/");
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                var n = response.status;
                if (n !== 204) {
                  if (n >= 400 && n < 500) {
                    return Js_promise.then_((function (json) {
                                  return Promise.resolve(ErrorData.Decode.safeDecodeError(json));
                                }), Fetch.$$Response.json(response));
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: response
                            });
                }
              }), fetch(url, request));
}

function changePhoneNumber(param) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.build(undefined)));
  var url = $$Request.makeUrl("api/v3/change-phone-number/");
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                var n = response.status;
                if (n !== 204) {
                  if (n >= 400 && n < 500) {
                    return Js_promise.then_((function (json) {
                                  return Promise.resolve(ErrorData.Decode.safeDecodeError(json));
                                }), Fetch.$$Response.json(response));
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: response
                            });
                }
              }), fetch(url, request));
}

function getCardData(cardUid) {
  var route = "api/v3/card/" + (cardUid + "/");
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, CardData.Decode.safeDecodeCardData);
  };
  return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}

function getCustomerData(param) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var callback = function (response) {
    return $$Request.checkResponse(response, CustomerData.Decode.safeDecodeCustomerData);
  };
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  return $$Request.makeRequest($$Request.makeUrl("api/v3/customer/"), request, headerlessRequest, callback, true);
}

function getSwapCardHistory(cardUid) {
  var route = "api/v3/card/" + (cardUid + "/exchange-history");
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, HistoryData.Decode.safeDecodeCardHistory);
  };
  return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}

function archiveGiftCard(cardUid) {
  var route = "api/v3/card/" + (cardUid + "/archive");
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.build(undefined)));
  var request = Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Put */3, undefined, undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, (function (x) {
                  return {
                          TAG: /* Ok */0,
                          _0: x
                        };
                }));
  };
  return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}

function confirmSecurityCode(securityCode) {
  var payload = Js_dict.fromList({
        hd: [
          "code",
          securityCode
        ],
        tl: /* [] */0
      });
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var url = $$Request.makeUrl("api/v3/customer/securitycode/validate/");
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                var n = response.status;
                if (n !== 200 && n !== 204) {
                  if (n >= 400 && n < 500) {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: {
                                  TAG: /* ServerError */2,
                                  _0: {
                                    TAG: /* ServerValidationError */0,
                                    _0: "Invalid security"
                                  }
                                }
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: response
                            });
                }
              }), fetch(url, request));
}

function pollOrderWithRetry(orderUrl, dispatchExchangeAction, retryCount) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Js_promise.$$catch((function (param) {
          return Promise.resolve(Curry._1(dispatchExchangeAction, {
                          TAG: /* NotifySwapFailure */5,
                          _0: "000"
                        }));
        }), Js_promise.then_((function (resp) {
              var hs = resp.headers;
              var retryAfterOpt = Belt_Option.flatMap(Fetch.$$Headers.get("retry-after", hs), (function (x) {
                      return Math.imul(Caml_format.int_of_string(x), 1000);
                    }));
              var retry = function (param) {
                Belt_Option.mapWithDefault(retryAfterOpt, undefined, (function (retryAfter) {
                        if (retryCount > 0) {
                          setTimeout((function (param) {
                                  pollOrderWithRetry(orderUrl, dispatchExchangeAction, retryCount - 1 | 0);
                                }), retryAfter);
                        } else {
                          Curry._1(dispatchExchangeAction, {
                                TAG: /* NotifySwapFailure */5,
                                _0: "000"
                              });
                        }
                      }));
              };
              Datadog.Logger.responseInfo("Response (polling)", resp, $$Request.logger);
              return Js_promise.then_((function (result) {
                            if (result.TAG !== /* Ok */0) {
                              return Promise.resolve(Belt_Option.isSome(retryAfterOpt) ? retry(undefined) : Curry._1(dispatchExchangeAction, {
                                                TAG: /* NotifySwapFailure */5,
                                                _0: "000"
                                              }));
                            }
                            var os = result._0;
                            if (os.status === "DRAFT" && Belt_Option.isSome(retryAfterOpt)) {
                              return Promise.resolve(retry(undefined));
                            }
                            if (os.status === "COMPLETED") {
                              return Promise.resolve(Curry._1(dispatchExchangeAction, /* NotifySwapSuccess */12));
                            }
                            if (os.status === "PROCESSING" && Belt_Option.isSome(retryAfterOpt)) {
                              return Promise.resolve(retry(undefined));
                            }
                            if (os.status === "FAILED") {
                              return Promise.resolve(Curry._1(dispatchExchangeAction, {
                                              TAG: /* NotifySwapFailure */5,
                                              _0: "000"
                                            }));
                            }
                            if (os.status === "CANCELLED") {
                              return Promise.resolve(Curry._1(dispatchExchangeAction, {
                                              TAG: /* NotifySwapFailure */5,
                                              _0: "000"
                                            }));
                            }
                            var errorData = os.error;
                            return Promise.resolve(errorData !== undefined ? Curry._1(dispatchExchangeAction, {
                                              TAG: /* NotifySwapFailure */5,
                                              _0: String(errorData.code)
                                            }) : (
                                          Belt_Option.isSome(retryAfterOpt) ? retry(undefined) : Curry._1(dispatchExchangeAction, {
                                                  TAG: /* NotifySwapFailure */5,
                                                  _0: "000"
                                                })
                                        ));
                          }), $$Request.checkResponse(resp, OrderStatus.Decode.safeDecodeOrderStatus));
            }), fetch(orderUrl, request)));
}

function exchange(swapCard, cart, dispatchExchangeAction) {
  var uid = swapCard !== undefined ? (
      swapCard.TAG === /* WalletCard */0 ? swapCard._0.uid : swapCard._0.uid
    ) : "";
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withPreferRespondAsync(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined)))));
  var route = "api/v3/exchange/" + (uid + "/");
  var payload = ExchangeData.Encode.exchange({
        items: Belt_List.map(cart, (function (swapItem) {
                return {
                        productCode: Belt_Option.getWithDefault(swapItem.productCode, ""),
                        productThemeCode: Belt_Option.mapWithDefault(Belt_Array.get(swapItem.card.themes, 0), "", (function (theme) {
                                return theme.code;
                              }))
                      };
              }))
      });
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var url = $$Request.makeUrl(route);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (resp) {
                Datadog.Logger.responseInfo("Response " + url, resp, $$Request.logger);
                var hs = resp.headers;
                var orderUrlOpt = Fetch.$$Headers.get("content-location", hs);
                if (orderUrlOpt !== undefined) {
                  return Promise.resolve(pollOrderWithRetry(orderUrlOpt, dispatchExchangeAction, 5));
                } else {
                  return Promise.resolve(Curry._1(dispatchExchangeAction, {
                                  TAG: /* NotifySwapFailure */5,
                                  _0: "000"
                                }));
                }
              }), fetch(url, request));
}

function addWalletNotes(cardUid, notes) {
  var payload = Js_dict.fromList({
        hd: [
          "message",
          notes
        ],
        tl: /* [] */0
      });
  var route = "api/v3/card/" + (cardUid + "/note/");
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, (function (x) {
                  return {
                          TAG: /* Ok */0,
                          _0: x
                        };
                }));
  };
  return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}

function logout(param) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var url = $$Request.makeUrl("api/v3/signout/");
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
  return Js_promise.then_((function (response) {
                Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
                JsCookie.remove(AuthUtils.cookieName);
                JsCookie.remove("sessionid");
                Segment.signedOut({});
                Segment.reset(undefined);
                var n = response.status;
                if (n !== 200 && n !== 204) {
                  if (n >= 400 && n < 500) {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: {
                                  TAG: /* ServerError */2,
                                  _0: {
                                    TAG: /* ServerValidationError */0,
                                    _0: "Logout Failed"
                                  }
                                }
                              });
                  } else {
                    return Promise.resolve({
                                TAG: /* Error */1,
                                _0: ApiErrors.networkError(undefined, n)
                              });
                  }
                } else {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: ""
                            });
                }
              }), fetch(url, request));
}

function savedCards(param) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, CreditCardData.SavedCard.Decode.safeDecode);
  };
  return $$Request.makeRequest($$Request.makeUrl("api/v3/stripe/cards/"), request, headerlessRequest, callback, true);
}

function getOrders(sort, pageNumber) {
  var route = "api/v3/account/orders/?sort=" + (OrderData.Data.sortTypesToString(sort) + ("&page_size=6&page=" + String(pageNumber)));
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, OrderData.Decode.safeDecodeOrderData);
  };
  return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}

function getOrderDetails(orderUid, giftUid) {
  var route = giftUid !== undefined ? "api/v3/account/orders/" + (orderUid + ("/gift/" + giftUid)) : "api/v3/account/orders/" + orderUid;
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, OrderData.Decode.safeDecodeOrderDetailsData);
  };
  return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}

function getMyDetails(param) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Get */0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Get */0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, MyDetailsData.Decode.safeDecodeMyDetailsData);
  };
  return $$Request.makeRequest($$Request.makeUrl("api/v3/account/details/"), request, headerlessRequest, callback, true);
}

function patchAccountDetails(payload) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var url = $$Request.makeUrl("api/v3/account/details/");
  var request = Fetch.RequestInit.make(/* Patch */8, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Patch */8, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, MyDetailsData.Decode.safeDecodeMyDetailsData);
  };
  return $$Request.makeRequest(url, request, headerlessRequest, callback, true);
}

function deleteProfilePicture(param) {
  return patchAccountDetails(Js_dict.fromList({
                  hd: [
                    "profile_picture",
                    null
                  ],
                  tl: /* [] */0
                }));
}

function updateMyDetails(firstName, lastName, birthdate) {
  return patchAccountDetails(Js_dict.fromList({
                  hd: [
                    "first_name",
                    firstName
                  ],
                  tl: {
                    hd: [
                      "last_name",
                      lastName
                    ],
                    tl: {
                      hd: [
                        "birthdate",
                        birthdate !== "" ? birthdate : null
                      ],
                      tl: /* [] */0
                    }
                  }
                }));
}

function resendGiftCard(resendGiftNotificationUrl) {
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.build(undefined)));
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, undefined, undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, ResendGiftData.Decode.safeDecodeResendResponse);
  };
  return $$Request.makeRequest(resendGiftNotificationUrl, request, headerlessRequest, callback, true);
}

function updateFailedOrder(payload) {
  var body = Js_dict.fromList({
        hd: [
          "new_email",
          Belt_Option.mapWithDefault(payload.newEmail, null, (function (newEmail) {
                  return newEmail;
                }))
        ],
        tl: {
          hd: [
            "new_phone",
            Belt_Option.mapWithDefault(payload.newPhone, null, (function (newPhone) {
                    return newPhone;
                  }))
          ],
          tl: /* [] */0
        }
      });
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Post */2, Caml_option.some(headers), Caml_option.some(JSON.stringify(body)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(body)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, ResendGiftData.Decode.safeDecodeResendResponse);
  };
  return $$Request.makeRequest(payload.url, request, headerlessRequest, callback, true);
}

function editScheduleDelivery(scheduledDeliveryAt, updateGiftScheduledDeliveryUrl, recipientTimezone) {
  var payload = Js_dict.fromList({
        hd: [
          "scheduled_delivery_at",
          scheduledDeliveryAt === "" ? null : scheduledDeliveryAt
        ],
        tl: {
          hd: [
            "recipient_timezone",
            recipientTimezone === "" ? null : recipientTimezone
          ],
          tl: /* [] */0
        }
      });
  var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
  var request = Fetch.RequestInit.make(/* Put */3, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var headerlessRequest = Fetch.RequestInit.make(/* Put */3, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */3, /* SameOrigin */1, undefined, undefined, undefined, undefined, undefined)(undefined);
  var callback = function (response) {
    return $$Request.checkResponse(response, EditScheduleDeliveryData.Decode.safeDecodeResendResponse);
  };
  return $$Request.makeRequest(updateGiftScheduledDeliveryUrl, request, headerlessRequest, callback, true);
}

export {
  login ,
  register ,
  account ,
  forgotEmailAddress ,
  resetPassword ,
  changeEmailAddress ,
  changePhoneNumber ,
  getCardData ,
  getCustomerData ,
  getSwapCardHistory ,
  archiveGiftCard ,
  confirmSecurityCode ,
  pollOrderWithRetry ,
  exchange ,
  addWalletNotes ,
  logout ,
  savedCards ,
  getOrders ,
  getOrderDetails ,
  getMyDetails ,
  patchAccountDetails ,
  deleteProfilePicture ,
  updateMyDetails ,
  resendGiftCard ,
  updateFailedOrder ,
  editScheduleDelivery ,
}
/* Util Not a pure module */
